define(
    'viewmodels/secured/explorer/details/tabs/actions/ModifyFieldAction',[
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "services/service.dialog",
        "services/service.documents",
        "i19n!i19n/strings",
        "plugins/router"
    ],
    function (Action, dialogService, documentsService, i19n, router) {

        var ModifyFieldAction = (function (_super) {

            var _i19n = {
                action: {
                    name: i19n.to.modifyfield,
                    message: i19n.to.bulkchangeafieldsetting + "."
                }
            };

            __extends(Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-edit", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                var documentInfo = action.context.checkedDocuments();

                documentsService.actions.canModifyField(action.context.checkedDocuments())
                    .done(function (result) {
                        if (!result.success) {
                            dialogService.showDocumentActionErrorDialog(result).then(complete);
                        } else {
                            setData(documentInfo);
                            
                            complete();

                            router.navigate("actionsModifyfield");
                        }
                    });
            }

            function setData(context) {
                sessionStorage.setItem("modifyfield", JSON.stringify(context));
            }

            return _Action;

        })(Action);

        return ModifyFieldAction;
        
    });
